import React, { FC } from 'react';
import classNames from 'classnames';
import getCountMax from 'helpers/get-count-max';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';

import './category-tree-item.scss';

interface CategoryTreeItemProps {
    name: string;
    url: string;
    isParent?: boolean;
    isActive?: boolean;
    amount?: number;
}

const CategoryTreeItem: FC<CategoryTreeItemProps> = ({
    name,
    url,
    isParent = false,
    isActive = false,
    amount
}) => {
    return (
        <li
            className={classNames({
                'category-tree-item': !isParent,
                'category-tree-item--active': !isParent && isActive,
                'category-tree-item__parent': isParent,
                'category-tree-item__parent--active': isParent && isActive
            })}
        >
            {React.createElement(isActive ? 'span' : 'a', {
                href: !isActive ? url : void 0,
                title: !isActive ? name : void 0,
                rel: !isActive && !isParent ? SeoLinkRelEnum.FOLLOW : void 0
            }, (
                <>
                    {name}{' '}{amount ? <span className="amount">({getCountMax(amount)})</span> : ''}
                </>
            ))}
        </li>
    );
};

export default CategoryTreeItem;
